
import mixins from '../mixins/index';
import props from '../props';
export default {
	name: "v-image",
    mixins,
    props,
}
